import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchMyPurchasesParams {
  isProduct?: boolean;
  limit?: number;
  enabled?: boolean;
}

export const useFetchMyPurchases = (params: UseFetchMyPurchasesParams = {}) => {
  const { isProduct, limit = 10, enabled = true } = params;

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/order/my-purchases", {
      params: {
        query: {
          page: typeof pageParam === "number" ? pageParam : 1,
          limit,
          ...(isProduct !== undefined && { is_product: isProduct }),
        },
      },
    });

    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  } = useInfiniteQuery({
    queryKey: ["order", "my-purchases", isProduct, limit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;
      if (pagination?.hasNextPage) return pagination.page + 1;
      return undefined;
    },
    enabled,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  };
};
